module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/nav-signin/nav-signin.component.scss
// module id = ./src/app/components/navbar/nav-signin/nav-signin.component.scss
// module chunks = main